import { render, staticRenderFns } from "./PanelPage.vue?vue&type=template&id=2995ada4&scoped=true&"
import script from "./PanelPage.vue?vue&type=script&lang=js&"
export * from "./PanelPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2995ada4",
  null
  
)

export default component.exports